<template>
  <div class="policy" :class="[
    { 'animate__animated animate__zoomOutLeft': isDeleting },
    { deleting: wasDeleted },
    `policy--${leadTypeColor}`,
  ]">
    <div class="row row--policy box box--default">
      <div class="row__data row__data--small center-element">
        {{ date }}
      </div>
      <div class="row__data row__data--small center-element">
        <div class="status" :class="'status--' + statusId">{{ status }}</div>
      </div>
      <div class="row__data row__data--medium center-element">
        <div v-if="lead.branch_categories && lead.branch_categories.length > 0"
          style="width: 100%;  text-align: center;">
          <VSelect @click.stop v-if="lead.branch_categories.length > 1" style="width: 100%; background: 0;" :options="lead.branch_categories.map(category => ({
            label: category.name,
            value: category.id
          }))" label="label" :reduce="option => option.value" class="select select--default customer__dropdown"
            v-model="selectedCategory" />

          <span v-else>
            {{ lead.branch_categories[0].name }}
          </span>
        </div>
        <span v-else>{{ statics.empty }}</span>
      </div>
      <div class="row__data row__data--small center-element referal-column">
        {{ lead.referral.name || statics.empty }}
        <div class="referal-note" v-if="lead.referral_note">{{ lead.referral_note }}</div>
      </div>
      <div class="row__data row__data--medium">
        {{ name || statics.empty }}
      </div>

      <div class="row__data row__data--small center-element">
        <div v-if="lead.contact_method">
          <div v-if="lead.contact_method == 'phone'">
            <a class="icon__phone"></a>
          </div>
          <div v-if="lead.contact_method == 'email'">
            <a class="icon__mail"></a>
          </div>
        </div>
        <div v-else>
          {{ statics.empty }}
        </div>
      </div>
      <div class="row__data row__data--small center-element">
        {{ deadline || statics.empty }}
      </div>
      <div class="row__data row__data--large">
        <EditableComment v-if="lead.comment" :comment="lead.comment" :readonly="true" />
        <span v-else>{{ statics.empty }}</span>
      </div>

      <div class="row__data row__data--small">
        <div class="icon__pdf" v-if="$checkRolePermission('customer_edit')"
          :class="{ 'icon__pdf--active': lead.files && lead.files.length }" @click="openLeadFilesModal(lead)">
        </div>

        <div v-if="$checkRolePermission('customer_edit')" class="icon__edit" @click="openEditLeadModal()">
        </div>

        <div v-if="$checkRolePermission('customer_delete')" class="icon__delete"
          :class="{ 'icon__delete--active': activeDeleteId === lead.id }" tabindex="-1"
          @focusout="activeDeleteId = null" @click.stop="activeDeleteId = lead.id">
          <transition name="fade">
            <div class="delete" v-if="activeDeleteId === lead.id">
              <div class="delete__text">
                {{ $t('deleteModal.question') }} {{ $t('deleteModal.lead') }}?
              </div>
              <div class="delete__buttons">
                <div class="button button--confirm" @click.stop="confirmDelete()"></div>
                <div class="button button--cancel" @click.stop="activeDeleteId = null"></div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDisplayDate } from "@/helpers/dateFormatters";
import statics from "@/statics";
import { mapGetters } from "vuex";
import EditableComment from "@/partials/EditableComment";
import { fetchGlobalCustomer } from "@/helpers/accountDetailHelpers";
export default {
  name: "Lead",

  components: {
    EditableComment,
  },

  props: {
    lead: {
      required: true,
      type: Object,
    },

    index: {
      required: true,
      type: Number,
    },
  },

  data() {
    return {
      fetchGlobalCustomer,
      formatDisplayDate,
      statics,
      isDeleting: false,
      wasDeleted: false,
      showEditablePopup: false,
      activeDeleteId: null,
      selectedCategory: null,
    };
  },

  mounted() {
    if (!(this.$checkRolePermission('customer_access') || this.$checkRolePermission('customer_show'))) {
      this.$router.push('/dashboard');
    } else {
      if (this.lead.branch_categories && this.lead.branch_categories.length > 0) {
        this.selectedCategory = this.lead.branch_categories[0].id;
      }
    }
  },

  computed: {
    ...mapGetters(["leadForms"]),
    date() {
      return this.lead.created_at
        ? this.formatDisplayDate(this.lead.created_at)
        : this.statics.empty;
    },

    status() {
      return this.lead.status ? this.lead.status.name : this.statics.empty;
    },

    statusId() {
      return this.lead.status ? this.lead.status.id : this.statics.empty;
    },

    deadline() {
      return this.lead.deadline
        ? this.formatDisplayDate(this.lead.deadline)
        : this.statics.empty;
    },

    leadTypeColor() {
      return this.lead.priority ? `type-${this.lead.priority.type}` : null;
    },

    agents() {
      return this.leadForms.agents;
    },

    agent() {
      return this.lead.agent
        ? this.lead.agent.first_name || statics.empty
        : statics.empty;
    },

    name() {
      return this.lead.agent
        ? `${this.lead.agent.first_name} ${this.lead.agent.last_name}`
        : statics.empty;
    },
  },

  methods: {
    async confirmDelete() {
      this.activeDeleteId = null;
      this.isDeleting = true;
      await this.$store.dispatch("deleteLead", {
        leadId: this.lead.id,
        customerId: this.$route.params.id
      });
      this.wasDeleted = true;
    },


    openLeadFilesModal(lead) {
      this.$store.commit("setShowFilesEditModal", true);
      this.$store.commit("setFilesToEditId", lead.id);
      this.$store.commit("setFilesToEdit", lead.files);
      this.$store.commit("setFilesEditMode", 'Leads');
    },

    async openEditLeadModal() { 
      this.$store.commit('setLeadToEdit', this.lead);
      this.$store.commit('setShowAddLeadModal', true);
    },
  },
};
</script>

<style scoped lang="scss">
.referal-column {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .referal-note {
    font-size: 0.7em;
    margin-top: 10px;
  }
}

.status {
  padding: 8px 16px;
  border-radius: 10px;
  text-align: center;

  //new
  &--1 {
    background: #cfcdcda2;
  }

  //open
  &--2 {
    background: #003cff85;
  }

  //need analyse
  &--3 {
    background: #ffae0062;
  }

  //negotiation
  &--4 {
    background: #ff5e007c;
  }

  //won
  &--5 {
    background: #22db8e1a;
  }

  //lost
  &--6 {
    background: #ff00008f;
  }
}

.icon__phone,
.icon__mail,
.icon__edit,
.icon__delete,
.icon__pdf {
  display: block;
  height: 25px;
  width: 25px;
  cursor: pointer;
}

.icon__edit {
  margin: 0 10px;
}

.row__data--delete,
.icon__delete {
  position: relative;

  .delete {
    position: absolute;
    z-index: 3;
    background: var(--bg-1);
    right: 0%;
    top: 50%;
    transform: translateY(-50%);
    width: 330px;
    display: flex;
    align-items: center;
    border-radius: var(--radius-1);
    border: 1px solid var(--border-2);
    padding: 10px 20px;
    box-shadow: 0px 3px 6px var(--shadow-7);

    &__text {
      line-height: 20px;
      color: var(--text-9);
    }

    &__buttons {
      display: flex;
    }

    .button {
      width: 24px;
      height: 24px;
      cursor: pointer;
      transition: all 0.3s ease;

      &--confirm {
        background: url("../../assets/icons/default/confirm_icon.svg");
        margin: 0 15px;

        &:hover {
          background: url("../../assets/icons/default/confirm_hover_icon.svg");
        }
      }

      &--cancel {
        background: url("../../assets/icons/default/close_icon.svg");

        &:hover {
          background: url("../../assets/icons/default/close_hover_icon.svg");
        }
      }
    }
  }
}

.category {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.policy:before {
  display: none;
}

.policy .row__data:first-of-type {
  padding: 0 10px;
}


.center-element {
  justify-content: center !important;
}
</style>
